import React from 'react';
import Tippy from '@tippyjs/react';
import './style.scss';

// Defining the allowed values for the 'position' prop
type TooltipPosition =
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-start'
    | 'top-end'
    | 'bottom-start'
    | 'bottom-end'
    | 'left-start'
    | 'left-end'
    | 'right-start'
    | 'right-end';

interface TooltipIconProps {
    text: string;
    position?: TooltipPosition;
}

const TooltipIcon = ({ text, position }: TooltipIconProps) => {
    return (
        <Tippy content={text} placement={position} className='tippy-vw'>
            <button
                className='c-icon c-info-icon tooltip js-tooltip c-icon--[semantic-info]'
                aria-label='Tooltip icon'
            ></button>
        </Tippy>
    );
};

export default TooltipIcon;
